import { render, staticRenderFns } from "./VariableFormats.vue?vue&type=template&id=44ec5898"
import script from "./VariableFormats.vue?vue&type=script&lang=js"
export * from "./VariableFormats.vue?vue&type=script&lang=js"
import style0 from "./VariableFormats.vue?vue&type=style&index=0&id=44ec5898&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports